import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./ManageUser.module.css"
import plus from "../../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ToggleSlider from "./ToggleSlider";

const ManageUser = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  const [newUser, setNewUser] = useState({
    fullName: "",
    email: "",
    username: "",
    role: "",
    password: "",
    confirmPassword: ""
  });

  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/User');
  };

  // Pagination handlers
  const handleFirstPage = () => {
    if (currentPage > 1) {
      fetchUsers(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      fetchUsers(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) {
      fetchUsers(page);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      if (value !== null) {
        setBearer(value);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const searchUsers = async (searchQuery, page = 1) => {
    if (!bearer) {
      return;
    }

    setSearchLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.get(`${BASE_URL}/users/search`, {
        headers,
        params: {
          variable: searchQuery,
          page: page
        }
      });

      console.log('Search API Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error searching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setSearchLoading(false);
      setLoading(false);
    }
  };

  const fetchUsers = async (page = 1) => {
    if (searchTerm.trim()) {
      await searchUsers(searchTerm, page);
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      if (!bearer) {
        setLoading(false);
        return;
      }

      let url = `${BASE_URL}/users/fetch-all`;
      let params = {
        page
      };

      const hasContinent = selectedContinent && selectedContinent.value !== 'all';
      const hasRegion = selectedRegion && selectedRegion.value !== 'all';
      const hasProvince = selectedProvince && selectedProvince.value !== 'all';

      if (hasContinent || hasRegion || hasProvince) {
        url = `${BASE_URL}/users/get-by-filter`;
        const filterParams = { page };
        if (hasContinent) filterParams.continent_id = selectedContinent.value;
        if (hasRegion) filterParams.region_id = selectedRegion.value;
        if (hasProvince) filterParams.province_id = selectedProvince.value;
        params = filterParams;
      }

      const response = await axios.get(url, {
        headers,
        params
      });

      console.log('Users API Full Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setLoading(false);
    }
  };

  // Handle search input change with debounce
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.trim()) {
        setCurrentPage(1);
        searchUsers(searchTerm, 1);
      } else if (searchTerm === "") {
        setCurrentPage(1);
        fetchUsers(1);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  // Handle search form submission
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      setCurrentPage(1);
      searchUsers(searchTerm, 1);
    }
  };

  const handleTypeChange = (event) => {
    console.log(event.target)
    setSelectedType(event.target.value);
  };

  // Fetch continents for React Select
  const fetchContinents = async () => {
    setContLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const contList = response.data?.data;
      const options = contList.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...options
      ];

      setContinents(continentsWithAll);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching continents:", error);
        setContinents([{ label: "All Continents", value: "all" }]);
      }
    } finally {
      setContLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    setRegionLoading(true);
    try {
      let regionsData = [];

      if (continentId === 'all' || !continentId) {
        setRegions([{ label: "All Regions", value: "all" }]);
        return;
      }

      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const regionsWithAll = [
        { label: "All Regions", value: "all" },
        ...options
      ];

      setRegions(regionsWithAll);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([{ label: "All Regions", value: "all" }]);
    } finally {
      setRegionLoading(false);
    }
  };

  const fetchProvinces = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );
      console.log(response, "fullreponse");
      const provData = response?.data.data || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvinces(options);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Fetch regions for modal
  const fetchRegionsModal = async (continentId) => {
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      const regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setRegionsModal(options);
    } catch (error) {
      console.error("Error fetching regions for modal:", error);
      setRegionsModal([]);
    }
  };

  const fetchProvincesModal = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );

      console.log("Provinces Modal Response:", response);
      const provData = response?.data?.data  || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvincesModal(options);
    } catch (error) {
      console.error("Error fetching provinces for modal:", error);
      setProvincesModal([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Filter handlers
  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption);
    setSelectedRegion(null);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchRegions(selectedOption.value);
    } else {
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvinces(selectedOption.value);
    } else {
      setProvinces([]);
    }
  };

  const handleProvinceChange = (selectedOption) => {
    console.log("Selected Province:", selectedOption);
    setSelectedProvince(selectedOption);
  };

  // Modal filter handlers
  const handleContinentChangeModal = (selectedOption) => {
    setSelectedContinentModal(selectedOption);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    if (selectedOption) {
      fetchRegionsModal(selectedOption.value);
    }
  };

  const handleRegionChangeModal = (selectedOption) => {
    console.log("Selected Region Modal:", selectedOption);
    setSelectedRegionModal(selectedOption);
    setSelectedProvinceModal(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvincesModal(selectedOption.value);
    } else {
      setProvincesModal([]);
    }
  };

  const handleProvinceChangeModal = (selectedOption) => {
    console.log("Selected Province Modal:", selectedOption);
    setSelectedProvinceModal(selectedOption);
  };

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, selectedProvince, bearer]);

  // Fetch user types for dropdown
  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching user types:", error);
        setUserType([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchUsers(currentPage);
      fetchData1();
      fetchContinents();
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  }, [bearer]);

  // Reset form
  // const resetNewUserForm = () => {
  //   setFullName("");
  //   setEmail("");
  //   setPhone("");
  //   setSelectedType("");
  //   setModalError("");
  //   setSelectedContinentModal(null);
  //   setSelectedRegionModal(null);
  //   setSelectedProvinceModal(null);
  //   setRegionsModal([]);
  //   setProvincesModal([]);
  // };

  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    resetNewUserForm();
  };

  const handleShowCreateUserModal = () => {
    setShowCreateUserModal(true);
    setModalError("");
  };

  // Prepare user type options
  const userTypeOptions = userTypes.map(userType => ({
    value: userType.id,
    label: userType.name || userType.description || `Role ${userType.id}`,
    ...userType
  }));

  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 7 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };

  const fetchPermission = async () => {
    setPermLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/role/permissions`, { headers });
      const data = response.data?.data;
      const permissionId = data.map(item => item.id);
      setPermId(permissionId);

      const initialToggleStates = Object.fromEntries(data.map(item => [item.id, false]));

      setPermissions(data);
      setToggleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setPermissions([]);
    } finally {
      setPermLoading(false);
    }
  };

  const fetRoles = async () => {
    setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/role/full-permissions`, { headers });
      const data = response.data?.data;
      const rolessId = data.map(item => item.id);
      setRoleID(rolessId);

      const initialToggleStates = Object.fromEntries(data.map(item => [item.id, false]));

      setRoles(data);
      setRoleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setRoles([]);
    } finally {
      setRoleLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchPermission();
      fetRoles();
    }
  }, [bearer]);

  // Your existing toggle handlers...
  const handleToggleChange = (itemId) => {
    setToggleStates(prevToggleStates => ({
      ...prevToggleStates,
      [itemId]: !prevToggleStates[itemId],
    }));
  };

  const handleRoleToggleChange = (itemId) => {
    setRoleStates(prevRoleStates => {
      const updatedStates = {
        ...prevRoleStates,
        [itemId]: !prevRoleStates[itemId],
      };
      const allChecked = roles.every(role => updatedStates[role.id]);
      setRoleCheckAll(allChecked);
      const noneChecked = roles.every(role => !updatedStates[role.id]);
      if (noneChecked) setRoleCheckAll(false);
      return updatedStates;
    });
  };

  const handleCheckAllToggle = () => {
    const checkAllValue = !checkAll;
    setCheckAll(checkAllValue);
    const updatedToggleStates = Object.fromEntries(permissions.map(permission => [permission.id, checkAllValue]));
    setToggleStates(updatedToggleStates);
  };

  const handleCheckAllRoles = () => {
    const checkAllRoleValue = !roleCheckAll;
    setRoleCheckAll(checkAllRoleValue);
    const updatedToggleStates = Object.fromEntries(roles.map(role => [role.id, checkAllRoleValue]));
    setRoleStates(updatedToggleStates);
  };

  const [createLoading, setCreateLoading] = useState(false);

  const createUser = async () => {
    setCreateLoading(true);
    try {
      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.id);

      const selectedRoles = roles
        .filter((item) => roleStates[item.id])
        .map((item) => item.id);

      const payload = {
        name: fullName,
        email: email,
        phone_number: phone,
        type: selectedType,
        module: selectedToggle,
        permissions: selectedRoles,
        continent_id: selectedContinentModal?.value || '',
        region_id: selectedRegionModal?.value || '',
        province_id: selectedProvinceModal?.value || ''
      };

      console.log("Create User Payload:", payload);

      const response = await axios.post(
        `${BASE_URL}/users/create-new`,
        payload,
        { headers }
      );

      fetchUsers();
      handleCloseCreateUserModal();
      resetNewUserForm();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const toIdArray = (val, key = "id") => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(x => (typeof x === "object" ? x[key] : x));
    if (typeof val === "object" && Array.isArray(val[key])) return val[key];
    if (typeof val === "number" || typeof val === "string") return [Number(val)];
    return [];
  };

  const asToggleMap = (allIds, selectedIds) =>
    Object.fromEntries(allIds.map(id => [id, selectedIds.includes(id)]));

  const handleOpenEdit = async (user) => {
    setEditingUser(user);

    // Basic info
    setFullName(user.name || user.full_name || "");
    setEmail(user.email || "");
    setPhone(user.phone_number || user.phone || "");
    setSelectedType(String(user.user_type_id || user.type_id || user.type || ""));

    // Set React Select values for modal
    if (user.continent_id || user.continent?.id) {
      const continentOption = continents.find(c => c.value == user.continent_id || c.value == user.continent?.id);
      setSelectedContinentModal(continentOption);
      if (continentOption) {
        await fetchRegionsModal(continentOption.value);
      }
    }

    if (user.region_id || user.region?.id) {
      const regionOption = regionsModal.find(r => r.value == user.region_id || r.value == user.region?.id);
      setSelectedRegionModal(regionOption);
      if (regionOption) {
        await fetchProvincesModal(regionOption.value);
      }
    }

    if (user.province_id || user.province?.id) {
      const provinceOption = provincesModal.find(p => p.value == user.province_id || p.value == user.province?.id);
      setSelectedProvinceModal(provinceOption);
    }

    // Modules and Roles
    const userModuleIds = toIdArray(user.modules) || toIdArray(user.module_ids) || toIdArray(user.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));

    const userRoleIds = toIdArray(user.roles) || toIdArray(user.role_ids) || toIdArray(user.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));

    setShow1(true);
  };
  // Update the reset function to include all fields
  const resetNewUserForm = () => {
    setFullName("");
    setFullName1("");
    setEmail("");
    setEmail1("");
    setPhone("");
    setPhone1("");
    setSelectedType("");
    setModalError("");
    setSelectedContinentModal(null);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    setToggleStates({});
    setRoleStates({});
    setCheckAll(false);
    setRoleCheckAll(false);
  };

  // FIXED: Use permissions state instead of undefined variable
  useEffect(() => {
    if (!editingUser || !permissions.length) return;
    const userModuleIds = toIdArray(editingUser.modules) || toIdArray(editingUser.module_ids) || toIdArray(editingUser.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));
  }, [permissions, editingUser]);

  useEffect(() => {
    if (!editingUser || !roles.length) return;
    const userRoleIds = toIdArray(editingUser.roles) || toIdArray(editingUser.role_ids) || toIdArray(editingUser.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));
  }, [roles, editingUser]);

  const updateUser = async (user) => {
    setCreateLoading(true);
    try {
      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.id);

      const selectedRoles = roles
        .filter((item) => roleStates[item.id])
        .map((item) => item.id);

      const response = await axios.post(
        `${BASE_URL}/users/update-user`,
        {
          name: fullName,
          email: email,
          phone_number: phone,
          type: selectedType,
          module: selectedToggle,
          permissions: selectedRoles,
          continent_id: selectedContinentModal?.value,
          region_id: selectedRegionModal?.value,
          province_id: selectedProvinceModal?.value,
          user_id: editingUser.id
        },
        { headers }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

      handleClose1();
      resetNewUserForm();
      fetchUsers();

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div>
      <HeaderNav />

      {/* Create User Modal */}
      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New User & Assign Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}>User Information</h5>
            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  className="form-control"
                  as="select"
                  value={selectedType}
                  onChange={handleTypeChange}
                >
                  <option value="" disabled>Select Type</option>
                  {userType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* For Continent */}
              {selectedType === '2' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>

              )}

              {/* For Region */}
              {selectedType === '3' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Province */}
              {selectedType === '4' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}
            </div>
          </div>

          {/* Rest of your modal content (permissions, roles, etc.) */}
          <hr className={classes.divider} />

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                <ToggleSlider checked={checkAll} onChange={handleCheckAllToggle} />
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>User Modules</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {permLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  permissions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      <ToggleSlider
                        checked={toggleStates[item.id]}
                        onChange={() => handleToggleChange(item.id)}
                      />
                    </div>
                  ))
                )}
              </div>
            </>
          )}

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                <ToggleSlider checked={roleCheckAll} onChange={handleCheckAllRoles} />
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>Roles & Permissions</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {roleLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  roles.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      <ToggleSlider
                        checked={roleStates[item.id]}
                        onChange={() => handleRoleToggleChange(item.id)}
                      />
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCreateUserModal}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={createUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Creating...</> : "Save User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
      <Modal show={show1} onHide={handleClose1} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update User & Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}>User Information</h5>
            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  className="form-control"
                  as="select"
                  value={selectedType}
                  onChange={handleTypeChange}
                >
                  <option value="" disabled>Select Type</option>
                  {userType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* For Continent */}
              {selectedType === '2' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Region */}
              {selectedType === '3' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Province */}
              {selectedType === '4' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}
            </div>
          </div>

          {/* Rest of edit modal content */}
          <hr className={classes.divider} />

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                <ToggleSlider checked={checkAll} onChange={handleCheckAllToggle} />
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>User Modules</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {permLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  permissions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      <ToggleSlider
                        checked={toggleStates[item.id]}
                        onChange={() => handleToggleChange(item.id)}
                      />
                    </div>
                  ))
                )}
              </div>
            </>
          )}

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                <ToggleSlider checked={roleCheckAll} onChange={handleCheckAllRoles} />
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>Roles & Permissions</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {roleLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  roles.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      <ToggleSlider
                        checked={roleStates[item.id]}
                        onChange={() => handleRoleToggleChange(item.id)}
                      />
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={updateUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Updating...</> : "Update User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Main Content */}
      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remittances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Ledger</Button>
        </div>

        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage User</h3>
        <p className={classes.prgText}>Add, View, Edit, and Delete User.</p>

        <div className={classes.subContainer} style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', justifyContent: 'space-between', marginBottom: '-17px', marginTop: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, marginTop: '-17px' }}>
            {/* Continent Filter */}
            <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Continent</Form.Label>
              <Select
                onChange={handleContinentChange}
                options={continents}
                value={selectedContinent}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            {/* Region Filter */}
            <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                onChange={handleRegionChange}
                options={regions}
                value={selectedRegion}
                isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                onChange={handleProvinceChange}
                options={provinces}
                value={selectedProvince}
                isDisabled={!selectedRegion || selectedRegion?.value === 'all'}
                isLoading={provLoading}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
          </div>

          <div className={classes.statCount} style={{ flexShrink: 0, margin: '0 auto', marginRight: '5%' }}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Users</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{users.length}</p>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0 }}>
            {/* Search Form */}
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search users..."
              />
              <Search className={classes.searchIcon} size={16} />
              {searchLoading && (
                <div className={classes.searchSpinner}>
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{
                      width: '16px',
                      height: '16px'
                    }}
                  />
                </div>
              )}
            </div>

            {/* Print View Button */}
            <div>
              <button className={classes.loanBtn} onClick={handlePrintView}>
                <MdPrint size={18} style={{ marginRight: '2px' }} />
                Print
              </button>
            </div>

            {/* Add New User Button */}
            <div>
              <button className={classes.loanBtn} onClick={handleShowCreateUserModal}>
                <img src={plus} alt="plus" />New User
              </button>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>User Type</th>
                <th>Station</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading || searchLoading ? (
                <SkeletonLoader />
              ) : users.length > 0 ? (
                users.map((user, index) => (
                  <tr key={user.id || index}>
                    <td className={classes.textby}>{index + 1}</td>
                    <td className={classes.textby}>
                      <span className={classes.statucColor}>
                        {user.name || user.full_name || 'N/A'}
                      </span>
                    </td>
                    <td className={classes.textby}>{user.email || 'N/A'}</td>
                    <td className={classes.textby}>{user.phone_number || user.phone || 'N/A'}</td>
                    <td className={classes.textby}>{user.user_type || user.type_name || 'N/A'}</td>
                    <td className={classes.textby}>{user.display_name || user.display_name || 'N/A'}</td>
                    <td className={classes.btnAction}>
                      <button
                        onClick={() => handleOpenEdit(user)}
                        className={classes.actionBtn}
                        title="Edit"
                      >
                        <FaPen style={{ color: '#28a745', fontSize: '18px' }} />
                      </button>
                      <button className={classes.actionBtn} title="Delete">
                        <img src={DeleteIcon} alt="Delete" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No users found matching "${searchTerm}"` : "No users available. Create your first user above."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} users
          </p>
        </div>
      </div>
    </div>
  )
}

export default ManageUser;